<template>
    <div>
        <div class="timeline-body-head" v-if="story">
            <div class="timeline-body-head-caption">
                <span class="timeline-body-alerttitle font-dark-blue">{{ itemTitle(visit) }}</span>
                <span class="timeline-body-time font-medium-grey" v-tooltip :vtitle="createdAtTitle">
                    {{ story.created_at | datetime }}
                </span>

                <span class="timeline-body-time font-medium-grey" v-if="story">
                    {{ story.user.name }}
                </span>

                <div class="clearfix"></div>
            </div>

            <div class="clearfix"></div>
        </div>

        <div class="clearfix"></div>

        <div class="timeline-body-content"style="margin-top: 0">
            <div style="margin-bottom: 8px">
                <span :style="itemStatusStyle(visit)">{{{ itemStatus(visit) }}}</span>
                <span class="bullet"></span>
                <i class="fa fa-user"></i> Responsável: <b>{{ visit.event.user.name }}</b>
                <span class="bullet"></span>
                <i class="fa fa-clock-o"></i> Agendado para: <b>{{ visit.event | event_range_line }}</b>
            </div>

            <div v-if="visit.comment">
                <div v-if="visit.status !== 3" style="font-style: italic; border-left: 4px solid #428bca; padding: 8px; margin-bottom: 8px;">
                    <html-sandbox :html="visit.comment"></html-sandbox>
                </div>
                <div v-if="visit.status === 3" style="font-style: italic; border-left: 4px solid #cb5a5e; padding: 8px; margin-bottom: 8px;">
                    <html-sandbox :html="visit.comment"></html-sandbox>
                </div>
            </div>

            <div v-for="item in visit.items" style="margin: 0; margin-bottom: 8px;">
                <div v-if="item.type === 'PROPERTY'">
                    <delayed-property :id="item.item_id">
                        <div slot="extra" v-if="item.comment">
                            <div v-if="item.status !== 3" style="font-style: italic; padding: 8px; border-left: 4px solid #428bca;">
                                <html-sandbox :html="item.comment"></html-sandbox>
                            </div>
                            <div v-if="item.status === 3" style="font-style: italic; padding: 8px; border-left: 4px solid #cb5a5e;">
                                <html-sandbox :html="item.comment"></html-sandbox>
                            </div>
                        </div>
                    </delayed-property>
                </div>
            </div>

            <div>
                <span v-if="visit.status === 1">
                    <a class="btn btn-sm orange" target="_blank" @click="fireSelected">
                        <i class="fa fa-check"></i>
                        Adicionar nessa visita
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
const bus = require('sci/std/bus')

export default {
    props: {
        visit: {
            type: Object,
            twoWay: true
        },
        story: {
            type: Object,
            twoWay: true
        },
        title: {
            type: String,
            default: null
        },
        onSelected: {
            type: Function,
            default: null
        }
    },
    components: {
        PropertyLine: require('components/property/Line.vue'),
        DelayedProperty: require('./DelayedProperty.vue')
    },
    computed: {
        createdAtTitle () {
            return `Agendado para: ${this.$options.filters.event_range_line(this.visit.event)}<br />Criado em: ${this.$options.filters.datetime(this.visit.created_at)}`
        },
        scheduledTitle () {
            return `Agendado para: ${this.$options.filters.event_range_line(this.visit.event)}<br />Criado em: ${this.$options.filters.datetime(this.visit.created_at)}`
        }
    },
    methods: {
        fireSelected () {
            this.onSelected && this.onSelected(this.visit)
        },
        itemTitle (visit) {
            if (this.title) {
                return this.title
            }

            switch (parseInt(visit.status)) {
                case 1: return 'Visita agendada'
                case 2: return 'Visita concluída'
                case 3: return 'Visita cancelada'
                default: return 'Visita'
            }
        },
        itemStatusStyle (visit) {
            const style = {
                fontWeight: 'bold'
            }

            switch (parseInt(visit.status)) {
                case 1:
                    style.color = '#064382'
                    break;
                case 2:
                    style.color = '#45B6AF'
                    break;
                case 3:
                    style.color = '#cb5a5e'
                    break;
            }

            return style
        },
        itemStatus (visit) {
            switch (parseInt(visit.status)) {
                case 1: return '<i class="fa fa-clock-o"></i> Agendada'
                case 2: return '<i class="fa fa-check"></i> Concluída'
                case 3: return '<i class="fa fa-close"></i> Cancelada'
                default: return 'Visita'
            }
        },
        getPropertyUrl (property) {
            return `/properties/${property.id}`
        },
        cancel () {
            bus.$emit('visits:cancel', {
                form: this.visit.form_id,
                visit: this.visit.id
            })
        },
        update () {
            bus.$emit('visits:update', {
                form: this.visit.form_id,
                visit: this.visit.id
            })
        },
        view () {
            bus.$emit('visits:view', {
                form: this.visit.form_id,
                visit: this.visit.id
            })
        },
        finish () {
            bus.$emit('visits:finish', {
                form: this.visit.form_id,
                visit: this.visit.id
            })
        },
        showVisitStatement () {
            bus.$emit('visits:show-visit-statement', {
                form: this.visit.form_id,
                visit: this.visit.id
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// VisitItem.vue?0dbe4fad